var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _rect4, _path7, _path8, _rect5, _rect6, _path9, _path10, _rect7, _rect8, _path11, _path12, _rect9, _rect10, _path13, _path14, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 58,
    viewBox: "0 0 72 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.51392,
    y: 53.9883,
    width: 54.3765,
    height: 2.0054,
    rx: 1.0027,
    fill: "#468BA3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 55.9937,
    width: 58.4043,
    height: 2.0054,
    rx: 1.0027,
    fill: "#65A6B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3749 0.95309C35.5644 0.794793 35.8401 0.794793 36.0296 0.95309L63.3994 23.8105C63.7658 24.1166 63.5494 24.7133 63.072 24.7133H8.33246C7.85505 24.7133 7.63866 24.1166 8.00509 23.8105L35.3749 0.95309Z",
    fill: "#468BA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6975 0.222276C35.8775 0.0900288 36.1225 0.0900281 36.3024 0.222275L65.922 21.9902C66.3195 22.2824 66.1129 22.9125 65.6195 22.9125H6.38045C5.88712 22.9125 5.68048 22.2824 6.07801 21.9902L35.6975 0.222276Z",
    fill: "#82CEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7906 4.51104C35.9161 4.42345 36.0828 4.42345 36.2083 4.51104L57.3177 19.2491C57.6104 19.4534 57.4658 19.913 57.1089 19.913H14.89C14.5331 19.913 14.3885 19.4534 14.6812 19.2491L35.7906 4.51104Z",
    fill: "#64BCE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.999 9.13037C33.9349 9.13037 32.2617 10.9053 32.2617 13.0948C32.2617 15.2843 33.9349 17.0592 35.999 17.0592C38.0631 17.0592 39.7363 15.2843 39.7363 13.0948C39.7363 10.9053 38.0631 9.13037 35.999 9.13037ZM36.3217 15.2442V15.8025H35.8183V15.2505C34.9921 15.1304 34.6303 14.4103 34.6303 14.4103L35.1445 13.954C35.1445 13.954 35.4729 14.5604 36.0669 14.5604C36.395 14.5604 36.6439 14.3741 36.6439 14.0557C36.6439 13.3116 34.7539 13.4019 34.7539 12.0214C34.7539 11.4213 35.2014 10.989 35.818 10.8867V10.3289H36.3215V10.8867C36.7514 10.9467 37.2606 11.1868 37.2606 11.7031V12.0992H36.593V11.9071C36.593 11.7091 36.3552 11.5771 36.089 11.5771C35.7496 11.5771 35.5009 11.7571 35.5009 12.0092C35.5009 12.7713 37.3909 12.5852 37.3909 14.0317C37.3909 14.6264 36.9723 15.1419 36.3217 15.2442Z",
    fill: "#00013A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 24.7031H20.1943C20.1943 25.8502 19.2644 26.7801 18.1172 26.7801H12.6044C11.4573 26.7801 10.5273 25.8502 10.5273 24.7031Z",
    fill: "#82CEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 53.7812H20.1943C20.1943 52.6341 19.2644 51.7042 18.1172 51.7042H12.6044C11.4573 51.7042 10.5273 52.6341 10.5273 53.7812Z",
    fill: "#82CEF9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5413,
    y: 26.7808,
    width: 6.04183,
    height: 24.9243,
    fill: "#64BCE2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5684,
    y: 26.7812,
    width: 2.01394,
    height: 24.9243,
    fill: "#78CDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 24.7031H30.6672C30.6672 25.8502 29.7373 26.7801 28.5901 26.7801H23.0773C21.9302 26.7801 21.0002 25.8502 21.0002 24.7031Z",
    fill: "#82CEF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 53.7812H30.6672C30.6672 52.6341 29.7373 51.7042 28.5901 51.7042H23.0773C21.9302 51.7042 21.0002 52.6341 21.0002 53.7812Z",
    fill: "#82CEF9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0142,
    y: 26.7808,
    width: 6.04183,
    height: 24.9243,
    fill: "#64BCE2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0413,
    y: 26.7812,
    width: 2.01394,
    height: 24.9243,
    fill: "#78CDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4731 24.7031H41.1401C41.1401 25.8502 40.2102 26.7801 39.063 26.7801H33.5502C32.4031 26.7801 31.4731 25.8502 31.4731 24.7031Z",
    fill: "#82CEF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4731 53.7812H41.1401C41.1401 52.6341 40.2102 51.7042 39.063 51.7042H33.5502C32.4031 51.7042 31.4731 52.6341 31.4731 53.7812Z",
    fill: "#82CEF9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4871,
    y: 26.7808,
    width: 6.04183,
    height: 24.9243,
    fill: "#64BCE2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5142,
    y: 26.7812,
    width: 2.01394,
    height: 24.9243,
    fill: "#78CDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9453 24.7031H51.6122C51.6122 25.8502 50.6823 26.7801 49.5352 26.7801H44.0223C42.8752 26.7801 41.9453 25.8502 41.9453 24.7031Z",
    fill: "#82CEF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9453 53.7812H51.6122C51.6122 52.6341 50.6823 51.7042 49.5352 51.7042H44.0223C42.8752 51.7042 41.9453 52.6341 41.9453 53.7812Z",
    fill: "#82CEF9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9592,
    y: 26.7808,
    width: 6.04183,
    height: 24.9243,
    fill: "#64BCE2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9863,
    y: 26.7812,
    width: 2.01394,
    height: 24.9243,
    fill: "#78CDEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.418 24.7031H62.0849C62.0849 25.8502 61.155 26.7801 60.0079 26.7801H54.495C53.3479 26.7801 52.418 25.8502 52.418 24.7031Z",
    fill: "#82CEF9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.418 53.7812H62.0849C62.0849 52.6341 61.155 51.7042 60.0079 51.7042H54.495C53.3479 51.7042 52.418 52.6341 52.418 53.7812Z",
    fill: "#82CEF9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4319,
    y: 26.7808,
    width: 6.04183,
    height: 24.9243,
    fill: "#64BCE2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 58.459,
    y: 26.7812,
    width: 2.01394,
    height: 24.9243,
    fill: "#78CDEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e10fc213a7071fc367e0e9c5acde6700.svg";
export { ForwardRef as ReactComponent };